import { Link } from "react-router-dom";
import { ArrowRight, Check, Zap } from "lucide-react";
import { motion } from "framer-motion";

export function HeroPricingCard() {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.1, duration: 0.4 }}
      className="order-first flex justify-center lg:order-none lg:justify-center"
    >
      <Link
        to="/planes"
        className="group relative flex w-full max-w-sm flex-col overflow-hidden rounded-3xl bg-gradient-to-br from-primary-deep to-primary p-6 text-center no-underline shadow-2xl shadow-primary-deep/30 transition-all duration-300 hover:scale-[1.02] hover:shadow-primary-deep/40 sm:max-w-md sm:rounded-[2rem] sm:p-8"
      >
        {/* Animated background glows */}
        <div className="absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-primary-foreground/10 blur-3xl animate-pulse-slow" />
        <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-accent-glow/25 blur-3xl animate-pulse-slow" />

        {/* Diagonal -40% ribbon */}
        <div className="absolute -right-10 top-5 z-20 rotate-45 bg-destructive px-10 py-1.5 text-[10px] font-black uppercase tracking-[0.15em] text-destructive-foreground shadow-lg sm:-right-12 sm:top-6 sm:px-12 sm:py-2 sm:text-xs">
          -40% OFF
        </div>

        <div className="relative z-10">
          {/* Launch offer label */}
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary-foreground/80">
            Oferta de lanzamiento
          </p>

          {/* Original price + discount chip */}
          <div className="mt-3 flex items-center justify-center gap-2">
            <span className="text-lg font-semibold text-primary-foreground/55 line-through sm:text-xl">
              249 MXN
            </span>
            <span className="rounded-full bg-destructive px-2 py-0.5 text-[10px] font-black uppercase tracking-wider text-destructive-foreground">
              -40%
            </span>
          </div>

          {/* Main price */}
          <p className="mt-1 text-5xl font-black tracking-tighter text-primary-foreground sm:text-6xl">
            149 MXN
          </p>

          <p className="text-base font-bold text-primary-foreground/90 sm:text-lg">
            Precio de introducción
          </p>

          {/* Free trial badge - PROMINENT */}
          <div className="mt-3 w-full rounded-2xl border-2 border-yellow-300/60 bg-yellow-400/20 px-4 py-2.5 backdrop-blur-sm shadow-[0_0_20px_rgba(250,204,21,0.25)]">
            <p className="flex items-center justify-center gap-2 text-sm font-black text-primary-foreground sm:text-base">
              <Zap className="h-4 w-4 text-yellow-300" />
              3 Días de Prueba Gratis
              <Zap className="h-4 w-4 text-yellow-300" />
            </p>
            <p className="mt-0.5 text-[11px] font-medium text-primary-foreground/70 sm:text-xs">
              Sin cargo hasta que decidas quedarte
            </p>
          </div>

          {/* Urgency container */}
          <div className="mt-3 w-full rounded-2xl border border-primary-foreground/10 bg-black/20 px-4 py-2.5 backdrop-blur-sm">
            <p className="text-sm font-bold text-primary-foreground">
              Solo hasta el ENARM 2026
            </p>
          </div>

          {/* Mini benefits */}
          <ul className="mt-4 space-y-1.5 text-left text-sm text-primary-foreground/90">
            {[
              "Acceso completo a flashcards",
              "Simuladores ilimitados",
              "Progreso y estadísticas",
            ].map((benefit) => (
              <li key={benefit} className="flex items-center gap-2">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-primary-foreground/20">
                  <Check className="h-2.5 w-2.5 text-primary-foreground" />
                </span>
                <span className="font-medium">{benefit}</span>
              </li>
            ))}
          </ul>

          {/* CTA */}
          <div className="mt-5 flex w-full items-center justify-center gap-2 rounded-2xl bg-primary-foreground px-5 py-3 text-sm font-black uppercase tracking-[0.15em] text-primary-deep shadow-lg transition-transform group-hover:translate-x-0.5 group-active:scale-[0.98] sm:py-3.5">
            Comenzar prueba gratis
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
